var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 782,
    height: 212,
    viewBox: "0 0 782 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.815 156.584V55.1016H226.169L195.042 115.653L163.897 55.1016H121.837V156.584H141.142V94.8066L172.927 156.584H193.193L224.96 94.8066V156.584H268.815Z",
    fill: "#0A2C57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.855 55.1016H62V156.584H105.855V55.1016Z",
    fill: "#0A2C57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.942 146.48V55.1016H629.061V156.584H719.1V111.605L674.942 146.48Z",
    fill: "#0A2C57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.48 105.709C520.48 99.8317 518.471 89.3727 514.454 82.9801C510.436 76.5698 505.121 71.3137 498.508 67.194C491.895 63.0743 484.269 60.0201 475.665 58.0668C467.043 56.0958 458.048 55.1191 448.698 55.1191C437.018 55.1191 405.482 55.1724 405.482 55.1724V156.601H448.698C458.066 156.601 467.043 155.625 475.665 153.654C484.287 151.683 491.895 148.646 498.508 144.526C505.121 140.407 510.436 135.151 514.454 128.74C518.471 122.33 520.48 111.676 520.48 105.727V105.709ZM455.044 145.61H448.573V66.1108H455.062C465.088 66.1108 472.003 75.2202 473.23 88.2895C474.332 100.169 474.083 115.795 473.23 123.413C471.754 136.376 465.088 145.61 455.044 145.592V145.61Z",
    fill: "#0A2C57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.558 134.423C374.924 142.396 397.234 117.376 397.234 93.7592C397.234 67.9048 370.231 51 338.109 51C298.662 51 277.33 75.4516 277.33 103.135C277.33 130.818 293.151 153.406 326.234 159.159C357.539 164.593 380.133 149.392 383.599 143.994V138.507C371.405 146.764 336.26 147.404 326.038 135.844C325.647 135.4 325.558 134.974 325.558 134.405V134.423ZM324.261 80.3703C324.261 74.546 325.185 64.4244 337.238 64.4244C349.29 64.4244 349.895 74.6348 350.215 80.3703C350.57 86.8695 350.677 101.359 350.215 107.13C349.237 119.17 341.611 129.433 324.314 129.345C324.314 129.345 324.261 89.5508 324.261 80.3881V80.3703Z",
    fill: "#0A2C57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M572.69 55.1016H528.835V156.584H572.69V55.1016Z",
    fill: "#0A2C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoEng);
export default __webpack_public_path__ + "static/media/main-logo-eng.cbb37d9db79f74b0c349b3b1fd818d69.svg";
export { ForwardRef as ReactComponent };